// Module
var code = "<svg width=\"6\" height=\"12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 12V0L.707 5.293a1 1 0 0 0 0 1.414L6 12Z\"/></svg>";
// Exports
export default code;